import i18next from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"
import { isDev } from "./env"

export const supportedLanguages = ["en", "ru"]
export type TLocale = (typeof supportedLanguages)[number]

i18next
  .use({
    type: "backend",
    read: async (language: string, namespace: string, callback) => {
      const data = await import(`@/public/locales/${language}/${namespace}.json`)
      callback(null, data)
    },
  })
  .use(LanguageDetector)
  .use(initReactI18next)

if (isDev)
  i18next.use({
    type: "logger",
    log: (msg: string) => {
      const [type, ...rest] = msg
      if (type != "i18next::translator: missingKey") return
      if (rest[0] == "en") return
      console.log(type, rest.slice(1, 3))
    },
    warn: (msg: string) => console.warn(msg),
    error: (msg: string) => console.error(msg),
  })

i18next.init({
  // lng: "en",
  debug: false,
  supportedLngs: supportedLanguages,
  fallbackLng: supportedLanguages[0],
  load: "languageOnly",
  ns: ["common", "tags"],
  interpolation: {
    escapeValue: false,
  },
})

export const t = i18next.t.bind(i18next)

export default i18next
